import React from "react";
import { Center, Spinner } from "@chakra-ui/react";

function Loading() {
  return (
    <Center position="absolute" top="0" left="0" right="0" bottom="0">
      <Spinner size="xl" />
    </Center>
  );
}

export { Loading };
